<template>
  <div class="familyIndex">
    <!-- <Sfq></Sfq> -->
    <NewSfq></NewSfq>
  </div>
</template>

<script>
import NewSfq from '@/components/newsfq.vue'
export default {
  name: 'FamilyIndex',
  components: {
    NewSfq,
  }
}
</script>

<style lang="less" scoped>
.familyIndex {
  max-width: 1920px;
  // overflow: hidden;
  margin: 0 auto;
}
</style>